
import { tradeDateRange, contracts } from '@/components/ContractBilling/BaseStore/contractsBase';

export default {
  dockConfig: {
    visible: false,
    alignment: 'left',
  },
  isSearchDialogVisible: false,
  fields: [{
    caption: 'TRADE DATE',
    dataField: 'tradingDate',
    dataType: 'date',
    format: 'MM/dd/yyyy',
    area: 'row',
    expanded: true,
  }, {
    caption: 'HOUR',
    dataField: 'tradingHour',
    dataType: 'number',
    area: 'row',
    expanded: true,
  }, {
    caption: 'INTERVAL',
    dataField: 'tradingInterval',
    dataType: 'number',
    area: 'filter',
    expanded: true,
  }, {
    caption: 'PRICE NODE',
    dataField: 'priceNode',
    dataType: 'string',
    area: 'column',
    expanded: true,
  }, {
    caption: 'VALUE',
    dataField: 'value',
    dataType: 'number',
    area: 'data',
    summaryType: 'sum',
    format: '#,##0.#######',
    expanded: true,
  }, {
    caption: 'CONTRACT NAME',
    dataField: 'contractName',
    dataType: 'string',
    area: 'filter',
    expanded: true,
  }, {
    caption: 'PRICE TYPE',
    dataField: 'priceType',
    dataType: 'string',
    area: 'filter',
    expanded: true,
  }, {
    caption: 'PRODUCT TYPE',
    dataField: 'productType',
    dataType: 'string',
    area: 'filter',
    expanded: true,
  }, {
    caption: 'MARKET TYPE',
    dataField: 'marketType',
    dataType: 'string',
    area: 'filter',
    expanded: true,
  }, {
    caption: 'SOURCE SYSTEM',
    dataField: 'sourceSystem',
    dataType: 'string',
    area: 'filter',
    expanded: true,
  }],
  searchFiltersConfig: {
    tradeDateRange,
    contracts,
  },
};